export const BRAND_NAME = 'PlayBetExch';
// Note: It is the main site url. Ex - sky11.com, etc.
export const BRAND_DOMAIN = 'playbetexch.com';
export const PROVIDER_ID = 'BetFair';
